import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';

Vue.use(VueI18n);
const locales = ['en_US', 'zh_CN', 'pt_PT', 'fr_FR', 'de_DE', 'es_ES', 'ja_JP', 'ko_KO', 'vi_VI','tr_TR','it_IT'];

const loadLocaleMessages = () => {
  const messages = {};
  locales.forEach(locale => {
    try {
      messages[locale] = require(`./${locale}.json`);
    } catch (e) {
      console.warn(`Unable to load ${locale} locale:`, e);
      messages[locale] = {};
    }
  });
  return messages;
};

const messages = loadLocaleMessages();

const DEFAULT_LOCALE = 'en'; 

export const i18n = new VueI18n({
  locale: Cookies.get('jd.erp.lang') || DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  silentTranslationWarn: true,
  messages
});